import {useState} from 'react';
import { handleLogoOnChange} from '@/actions/pages/clients/careers/createJob';


function EditImage(props)
{
  const [selectedFile, setSelectedFile] = useState( props.logo_url || '/images/pages/career/LOGO.png');
  
  return(
          <>
            <div className={`image-upload`}>

              <label>
                <img alt="logo-image" src={selectedFile} className={'logo-image'}/>
              </label>
              
              <label htmlFor="file-input" className={'img-edit-icon'}>
                <img alt="icon-image" src='/icons/edit.png'/>
              </label>
            
              <input id         =   "file-input" 
                     type       =   "file"  
                     onChange   =   { (event) => handleLogoOnChange(event,setSelectedFile)} 
                     accept     =   ".png, .jpg, .jpeg" />
            
            </div>
          </>
        )
  
}

export default EditImage;